<template>
  <div :class="{ 'meal-zhiyun-version': versionConfig.ZHIYUN_VERSION }">
    <a-row :gutter="20">
      <a-col :span="12" class="left-cnt">
        <data-table ref="consumeTable" :option="option1" class="meal-table">
          <template slot="headAction">
            <a-button type="primary" @click="autoReadCard" :loading="loading">
              {{ loading ? "自动刷卡中……" : "自动刷卡" }}
            </a-button>
            <a-button
              v-if="timer"
              type="danger"
              style="margin-left:10px"
              @click="stopRead"
              >停止</a-button
            >
            <small style="color: #f00;margin-left:5px">{{ errorMsg }}</small>
            <h3 class="item-tit">待用餐客人</h3>
          </template>
          <template slot="rowAction" slot-scope="text, record">
            <a-button
              type="link"
              v-if="record.RestQuantity > 0"
              size="small"
              @click="consumeBreakfast(record)"
              >消费</a-button
            >
          </template>
        </data-table>
        <div class="count-total">
          <span>
            用餐总数：<em>{{ recordInfo.Num }}</em
            ><small>/份</small></span
          >
          <span>
            使用总数：<em>{{ recordInfo.ConsumeNum }}</em
            ><small>/份</small></span
          >
          <span>
            剩余总数：<em>{{ recordInfo.RestNum }}</em
            ><small>/份</small></span
          >
        </div>
      </a-col>
      <a-col :span="12" class="right-cnt">
        <data-table ref="dataTable" :option="option" class="meal-table">
          <template slot="headAction">
            <a-button type="primary" class="read-card" @click="readCard(1)"
              >读卡</a-button
            >
            <span style="visible:hidden;display: block;height:32px"></span>
            <h3 class="item-tit">用餐记录</h3>
          </template>
        </data-table>
        <div class="count-total">
          <span>
            用餐总数：<em>{{ recordInfo.UsedConsumeNum }}</em
            ><small>/份</small></span
          >
        </div>
      </a-col>
    </a-row>

    <a-modal
      title="消费数量"
      :visible="visible"
      :destroyOnClose="true"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      @ok="consumeSubmit"
      @cancel="visible = false"
    >
      <a-form :form="form" layout="inline">
        <a-form-item label="消费数量">
          <a-input-number
            style="width:150px"
            :min="1"
            :max="currentItem.RestQuantity"
            v-decorator="[
              'ConsumeQuantity',
              { rules: [{ required: true, message: '请填写消费数量' }] }
            ]"
          ></a-input-number>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import { cache } from "@/utils/common";
// import moment from "moment";
// import cloneDeep from "lodash/cloneDeep";
export default {
  name: "Breakfast",
  components: {
    DataTable
  },
  data() {
    return {
      versionConfig,
      option: {},
      option1: {},
      defaultItem: {},
      visible: false,
      currentItem: {},
      confirmLoading: false,
      form: this.$form.createForm(this, { name: "coordinated" }),
      timer: null,
      loading: false,
      recordInfo: {},
      searchParams: {},
      preCardId: "",
      errorMsg: ""
    };
  },
  created() {
    this.getDefaultItem();
    this.AccountDate = cache.get("user").AccountDate;
    this.option1 = {
      grid: {
        api: "Breakfast_List",
        props: {
          scroll: {
            y: window.document.body.clientHeight - 310
          }
        },
        pagination: false,
        dataField: "Data",
        columns: [
          {
            title: "订单号",
            width: 80,
            dataIndex: "OrderNo",
            customRender: (text, record) => {
              const orderDetail = {
                click: () => {
                  this.orderDetail(record);
                }
              };
              return (
                <a-button type="link" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          },
          {
            title: "房号",
            width: 80,
            dataIndex: "RoomNo"
          },
          {
            title: "客人名称",
            width: 100,
            dataIndex: "GuestName"
          },
          {
            title: "价构名称",
            dataIndex: "PriceStructureName"
          },
          {
            title: "用餐总数",
            width: 80,
            dataIndex: "Quantity"
          },
          {
            title: "使用数量",
            width: 80,
            dataIndex: "ConsumeQuantity"
          },
          {
            title: "剩余数量",
            align: "right",
            width: 80,
            dataIndex: "RestQuantity"
          },
          {
            title: "操作",
            width: 80,
            dataIndex: "Action",
            scopedSlots: { customRender: "rowAction" }
          }
        ],
        onLoad: res => {
          this.recordInfo = res.Data;
          res.Data = res.Data.UsingRecords;
          return res;
        }
      }
    };
    this.option = {
      headSearch: {
        width: 500,
        colnum: 2,
        content: [
          {
            label: "查询历史记录",
            type: "date",
            name: "AccountDate"
          },
          {
            label: "房号",
            name: "RoomNo"
          }
        ],
        onSubmitBefore: values => {
          this.searchParams = { ...values };
          return values;
        }
      },

      grid: {
        api: "Breakfast_List",
        pagination: false,
        dataField: "Data",
        props: {
          scroll: {
            y: window.document.body.clientHeight - 310
          }
        },
        columns: [
          {
            title: "订单号",
            width: 80,
            dataIndex: "OrderNo",
            customRender: (text, record) => {
              const orderDetail = {
                click: () => {
                  this.orderDetail(record);
                }
              };
              return (
                <a-button type="link" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          },
          {
            title: "房号",
            width: 80,
            dataIndex: "RoomNo"
          },
          {
            title: "客人名称",
            width: 80,
            dataIndex: "GuestName"
          },
          {
            title: "价构名称",
            width: 150,
            dataIndex: "PriceStructureName"
          },
          {
            title: "用餐总数",
            width: 80,
            dataIndex: "Quantity"
          },
          {
            title: "使用记录",
            dataIndex: "ConsumeRecord",
            align: "left",
            customRender: text => {
              if (text) {
                const h = this.$createElement;
                const arr = text.split("\r\n").map(el => {
                  return h("p", el);
                });
                return h("div", [arr]);
              }
            }
          }
        ],
        onLoad: res => {
          res.Data = res.Data.UsedRecords;
          this.$refs.consumeTable.onHeadSearchSubmit({ ...this.searchParams });
          return res;
        }
      }
    };
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    //获取系统参数值
    getDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    readCardList(CardId) {
      const values = this.$refs.dataTable.getRef("headSearchForm").getData();
      this.$refs.dataTable.onHeadSearchSubmit({
        ...values,
        CardId: CardId
      });
    },
    consumeBreakfast(record) {
      this.currentItem = record;
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({ ConsumeQuantity: record.RestQuantity });
      });
    },
    consumeSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          this.$post("Breakfast_Consume", {
            Id: this.currentItem.Id,
            ConsumeQuantity: values.ConsumeQuantity
          })
            .then(() => {
              this.$message.success("操作成功！");
              this.visible = false;
              this.confirmLoading = false;
              this.$refs.consumeTable.reload();
              this.$refs.dataTable.headSearch();
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    stopRead() {
      this.preCardId = "";
      this.loading = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
        this.errorMsg = "";
      }
    },
    autoReadCard() {
      this.readCard(2);
      this.timer = setInterval(() => {
        this.readCard(2);
      }, 5 * 1000);
    },
    readCard(status) {
      let url = "";
      if (isNaN(this.defaultItem.LocalServicePort)) {
        url = this.defaultItem.LocalServicePort;
      } else {
        url =
          "http://localhost:" +
          this.defaultItem.LocalServicePort +
          "/Lock/Read";
      }
      if (status == 2) {
        this.loading = true;
      }

      this.$post(url)
        .then(res => {
          this.loading = false;
          if (res.Data && res.Data.CardId && res.Data.CardId != 0) {
            const cardId = res.Data.CardId;
            if (status == 1) {
              this.errorMsg = "";
              this.readCardList(cardId);
            } else {
              if (this.preCardId != cardId) {
                this.$post(
                  "Breakfast_Consume",
                  {
                    CardId: cardId
                  },
                  { alertError: false }
                )
                  .then(() => {
                    this.preCardId = cardId;
                    this.$message.success("操作成功！");
                    this.$refs.consumeTable.reload();
                    this.$refs.dataTable.headSearch();
                    this.errorMsg = "";
                  })
                  .catch(err => {
                    this.errorMsg = err.data.Message;
                    this.preCardId = "";
                  });
              }
            }
          } else {
            this.preCardId = "";
            this.errorMsg = "卡信息不存在";
          }
        })
        .catch(res => {
          this.preCardId = "";
          this.loading = false;
          if (!res.message || res.message == "Network Error") {
            this.$message.error("请检查读卡接口服务是否启动");
          }
        });
    },
    orderDetail(record) {
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: record.OrderId,
          showBtn: false
        });
      } else {
        OrderDetailModal({
          orderId: record.OrderId,
          showBtn: false
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.read-card {
  position: absolute;
  right: 0;
  top: 3px;
}
.meal-table.data-table {
  // background: #f0f2f5;
  min-height: calc(100vh - 155px);
  border-bottom: 1px solid rgba(24, 144, 255, 0.2);
  .ant-table-small.ant-table-bordered,
  .ant-table-thead > tr > th {
    border-radius: 0 !important;
  }
  /deep/ .head {
    height: 75px;
    background: #fff;
    .head-search {
      margin-right: 80px;
    }
  }
}
.item-tit {
  margin-top: 10px;
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  position: absolute;
  left: 0;
  background: rgba(24, 144, 255, 0.2);
  height: 34px;
  line-height: 34px;
  padding-left: 10px;
}
.left-cnt,
.right-cnt {
  position: relative;
  /deep/ .ant-table-small {
    border: 0;
    border-bottom: 1px solid #e8e8e8;
  }
  &:before {
    content: "";
    position: absolute;
    left: 10px;
    top: 76px;
    height: calc(100vh - 232px);
    width: 1px;
    background: rgba(24, 144, 255, 0.2);
    z-index: 10;
  }
  &:after {
    content: "";
    position: absolute;
    right: 10px;
    top: 76px;
    height: calc(100vh - 232px);
    width: 1px;
    background: rgba(24, 144, 255, 0.2);
    z-index: 10;
  }
  .count-total {
    position: absolute;
    bottom: 0;
    left: 10px;
    font-size: 16px;
    width: calc(100% - 21px);
    height: 40px;
    line-height: 36px;
    text-align: right;
    padding-right: 15px;
    background: #d1e9ff;
    span {
      margin-left: 15px;
      em {
        font-size: 18px;
        color: #f00;
        font-style: normal;
      }
    }
  }
}
.meal-zhiyun-version {
  .item-tit {
    background: #7398c9;
    color: #fff;
  }
  .left-cnt .count-total,
  .right-cnt .count-total {
    background: #7398c9;
    color: #fff;
    span em {
      color: #fffc00;
      font-weight: bold;
    }
  }
}
</style>
